import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/ProductCard.css";
import { useWishlist } from "../context/WishlistContext";
import { isNewProduct } from "../utils/dateUtils";

const ProductCard = ({ product }) => {
  const { isInWishlist, addToWishlist, removeFromWishlist } = useWishlist();

  if (!product.stock || product.stock <= 0 || product.outOfStock) {
    return null;
  }

  const isNew = isNewProduct(product.dateAdded);
  const isWishlisted = isInWishlist(product.id);
  const hasDiscount = product.discount && parseInt(product.discount) > 0;
  const hasBuyOneGetOne = product.offer === "Buy1Get1";

  const [primaryImage, secondaryImage] = product.images
    ? [product.images[0], product.images[1]]
    : [product.image, product.image2];

  const handleWishlistClick = (e) => {
    e.preventDefault();
    if (isWishlisted) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
  };

  const renderOfferTag = () => {
    if (hasDiscount) {
      return <span className="discount-tag">{product.discount}% OFF</span>;
    }
    if (hasBuyOneGetOne) {
      return <span className="offer-tag">Buy 1 Get 1</span>;
    }
    return null;
  };

  return (
    <Link to={`/product/${product.id}`} className="product-card">
      <div className="product-card-container">
        <div className="product-image-container">
          <img
            src={primaryImage}
            alt={product.name}
            className="primary-image"
          />
          <img
            src={secondaryImage}
            alt={product.name}
            className="secondary-image"
          />
          {renderOfferTag()}
          {isNew && <span className="new-tag">NEW</span>}
          <button
            className={`wishlist-button ${isWishlisted ? "active" : ""}`}
            onClick={handleWishlistClick}
          >
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </button>
        </div>
        <div className="product-info">
          <h3>{product.name}</h3>
          <p className="price">{product.price.replace("Rs.", "$")}</p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
